module.exports = __webpack_public_path__ + "static/media/timeup-image.2f9d00cf.png";